<template>
  <v-row>
    <v-col cols="12" sm="12">
      <TitleAndSearch
        :icon="'icon_user'"
        :title="$t('fleet_management.persons.persons.labels.title')"
        :showSearch="true"
      />
      <PersonsTabs />
    </v-col>
  </v-row>
</template>

<script>
import PersonsTabs from '@/components/persons/PersonsTabs.vue'
import TitleAndSearch from '@/components/TitleAndSearch.vue'

export default {
  name: 'PersonsList',
  components: {
    PersonsTabs,
    TitleAndSearch
  },
  data() {
    return {}
  },
  methods: {},
  computed: {},
  watch: {}
}
</script>

<style lang="scss" scoped></style>
